import { useEffect } from 'react';

import { useBusinessInfoContext } from 'contexts/BusinessContextProvider';
import { useTrialsContext } from 'contexts/TrialsContextProvider';
import useChangePage from 'hooks/useChangePage';
import { TRIAL_URL } from 'routes/constants';

import {
  BUSINESS_INFO_ROUTE,
  PROFILE_ROUTE,
  VERIFY_ACCOUNT_ROUTE,
} from '../constants';

const useTrialProtectedPageGuard = ({
  shouldHaveValidLogin,
  shouldHaveValidBusinessName,
  shouldHaveVerifiedAccount,
} = {}) => {
  const { validateBusinessName } = useBusinessInfoContext() || {};
  const changePage = useChangePage();
  const {
    accountExists,
    email,
    hasValidLogin,
    hasValidName,
    password,
    verifiedAccount,
  } = useTrialsContext() || {};

  useEffect(() => {
    // user needs to go to the start of the flow
    if (!email || !password || accountExists) {
      return changePage(TRIAL_URL, true);
    }

    const validAccount = hasValidLogin();
    const validName = hasValidName();

    if (
      (shouldHaveValidLogin || shouldHaveValidBusinessName) &&
      (!validAccount || !validName)
    ) {
      return changePage(PROFILE_ROUTE, true);
    }

    if (shouldHaveVerifiedAccount && !verifiedAccount) {
      return changePage(VERIFY_ACCOUNT_ROUTE, true);
    }

    if (shouldHaveValidBusinessName && !validateBusinessName()) {
      return changePage(BUSINESS_INFO_ROUTE, true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useTrialProtectedPageGuard;
